exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0d523888] .dropdown-link > a {\n  display: none;\n}\n[data-v-0d523888] .dropdown-link .dropdown {\n  opacity: 1;\n  position: relative;\n  top: unset;\n  right: unset;\n  pointer-events: all;\n  padding: 0;\n}\n[data-v-0d523888] .dropdown-link .dropdown .dropdown-inner {\n  border-radius: 0;\n  background-color: unset;\n  box-shadow: none;\n  min-width: 0;\n  padding: 0;\n}", ""]);

// exports
